import React, { forwardRef, useImperativeHandle } from 'react';
import classNames from 'classnames';
import { Button, Modal } from 'ncoded-component-library';
import {
  ModalProps,
  ModalRef,
} from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import useCallbackRef from 'hooks/useCallbackRef';
import { useTranslation } from 'react-i18next';
import { Form } from 'react-final-form';

import './ApplyToAllDataRoomsModal.styles.scss';

type ApplyToAllDataRoomsModalProps = {
  className?: string;
  onSubmit: (values?: any) => void;
} & ModalProps;

const ApplyToAllDataRoomsModal: React.ForwardRefRenderFunction<
  ModalRef,
  ApplyToAllDataRoomsModalProps
> = (props, ref) => {
  const { children, className, onSubmit, ...rest } = props;

  const [modal, modalRef] = useCallbackRef<ModalRef>();

  useImperativeHandle(ref, () => modal, [modal]);

  const classes = classNames('apply-to-all-data-rooms-modal', className);

  const { t } = useTranslation();

  return (
    <Modal
      ref={modalRef}
      className={classes}
      title={t('applyTheseSettingsToAllDR')}
      {...rest}
    >
      <Form
        onSubmit={onSubmit}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <p>{t('applyTheseSettingsToAllDRdescription')}</p>

            {children}

            <div className="actions">
              <Button variant="link" onClick={modal?.close}>
                {t('cancel')}
              </Button>

              <Button type="submit">{t('saveAsOrganisationDefaults')}</Button>
            </div>
          </form>
        )}
      />
    </Modal>
  );
};

export default forwardRef(ApplyToAllDataRoomsModal);
